import react from "react";

 function Footer (){
       return(
          <>
          <footer className="footer">
             <p>&copy; 2024 My Website.All Rights Reserved</p>
          </footer>
          </>
       );
 };

 export default Footer;
